<template>
  <header 
    class="HeaderSection"
    :class="SectionClassList">
    <h2 class="HeaderSection__title">
      {{ title }}
    </h2>
    
    <div 
      v-if="hasIntro"
      class="HeaderSection__content">
      <slot />
    </div>

    <div 
      v-if="hasMedia" 
      :style="mediaImageCSS"
      class="HeaderSection__image">
      <div class="HeaderSection__mediaLink">
        <Link 
          v-if="hasMediaLink"
          arrow
          label="MEER MEDIA"
          :to="mediaLinkTo" />
      </div>
    </div>

    <BtnClose 
      v-if="hasCloseBtn" 
      :to="closeLinkTo" />

  </header>
</template>

<script>

import BtnClose from '@/components/buttons/Close';
import Link from '@/components/Link';

export default {
  name: 'HeaderSection',
  components: {
    BtnClose, 
    Link
  },
  props: {
    title: {
      type: String,
      required: true
    },

    wide: {
      type: Boolean,
      default: false
    },

    mediaImageSrc: {
      type: [ String, Boolean],
      default: ''
    },

    // router-link to props
    closeLinkTo : {
      type: [Object, Boolean],
      default: false
    },
    mediaLinkTo: {
      type: [Object, Boolean],
      default: false
    },
  },
  computed: {
    hasCloseBtn() {
      return this.closeLinkTo !== false
    },
    hasMediaLink() {
      return this.mediaLinkTo !== false;
    },
    hasMedia() {
      return this.mediaImageSrc !== '' && this.mediaImageSrc !== false;
    },
    mediaImageCSS() {
      return {
        backgroundImage: `url(${this.mediaImageSrc})`
      }
    },
    hasIntro() {
      return !! this.$slots.default || !! this.$scopedSlots.default;
    },
    SectionClassList() {
      return {
        'HeaderSection--wide': this.wide
      }
    }
  }
}
</script>

<style lang="scss">

  .HeaderSection {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
  
    &__title {
      width: 100%;
      padding: 32px 64px 32px 32px;
      margin: 0;
      font-size: 30px;
      font-family: $font_header;
      color: white;
      background-color: $color_primary;
    }
    &__content {
      display: flex;
      flex-direction: column;
      padding: 16px 16px 16px 32px;
      // background: rgba(216, 216, 216, 0.5);
      background: $antraciet_blauw_light;
      border-top: 1px solid #979797;
      border-bottom: 1px solid #979797;

      p {
        font-family: $font_body;
        font-size: 16px;
        line-height: 24px;
        margin: 0 0 16px;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }

    &__image {
      position: relative;
      width: 100%;
      height: 200px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__mediaLink {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: right;
      background-color: rgba(0,0,0,0.5);
      padding: 8px;

      .Link {
        color: white;
        &:hover {
          color: #7CD7CB;
        }
      }
    }

    &--wide {
      flex-wrap: wrap;
      flex-direction: row;
    
      .HeaderSection {
        &__content {
          flex-grow: 1;
          max-width: calc(100% - 480px);
          border-bottom: 1px solid #979797;
        }
        &__image { 
          width: 480px;
          border-bottom: 1px solid #979797;
        }
      }
      .Content__facts {
        align-self: center;
      }
    }
  }
  

</style>
